import RichText from "@/components/RichText";
import { BODY, CONTAINER, DARK_BG, SECTION } from "../tokens";

// Positionnement B2B : photo à gauche (min 320px), trois paragraphes à droite.
export default function ProIntroSection({ props = {} }) {
  return (
    <section>
      <div className={`${CONTAINER} ${SECTION} grid gap-10 md:gap-11 [grid-template-columns:repeat(auto-fit,minmax(280px,1fr))] items-start`}>
      <div className="min-h-[320px]" style={DARK_BG}>
        {props.image_url && (
          <img
            src={props.image_url}
            alt={props.alt || ""}
            className="w-full h-full min-h-[320px] object-cover block"
            loading="lazy"
          />
        )}
      </div>
      <RichText as="div" preserveParagraphs className={`${BODY} [&_p]:mb-5 [&_p:last-child]:mb-0`} html={props.body} />
      </div>
    </section>
  );
}
